'use strict';

const widgetGeneratorV2 = {
    formData: {},
    widget: $('#discoFrameId'),
    fieldErrors: false,
    init: function() {
        widgetGeneratorV2.onCheckboxClick();
        widgetGeneratorV2.updateWidgetOnEveryFormChange();
        widgetGeneratorV2.onGetCodeClick();
        widgetGeneratorV2.onFullScreenClick();
        widgetGeneratorV2.onPickUpInputsClick();
        widgetGeneratorV2.onReturnEditClick();
        widgetGeneratorV2.onColorInputClick();
        widgetGeneratorV2.onResetButtonCLick();
        widgetGeneratorV2.onScrollToPreviewClick();
    },
    onGetCodeClick() {
        $('#wg-submit').on('click', function(e) {
            e.preventDefault();
            widgetGeneratorV2.getFormData();
            widgetGeneratorV2.validateRequiredFields();

            if (!widgetGeneratorV2.fieldErrors) {
                $('html').animate({ scrollTop: 0 }, 'slow');
                widgetGeneratorV2.generateLocationUrl();
                widgetGeneratorV2.addTextLinkToAffCodeSection();
                widgetGeneratorV2.addTextLinkToEmbedCodeSection();
                widgetGeneratorV2.onCopyButtonCodeClick('wg-aff-code-button', 'wg-aff-code-region');
                widgetGeneratorV2.onCopyButtonCodeClick('wg-embed-code-button', 'wg-embed-code-region');

                $('.wg-section.form').toggle(400);
                $('.wg-section.get-code').toggle(400);
            }
        });
    },
    /**
     *
     * @param {boolean} forPreview
     */
    getFormData(forPreview = false) {
        const hashTagUnicode = '%23';
        const rawFormData = $('#wg-form').serialize().split('&');
        widgetGeneratorV2.formData = {};

        rawFormData.forEach((inputKeyValue) => {
            const splitKeyValue = inputKeyValue.split('=');
            const fieldValue = (splitKeyValue[1].startsWith(hashTagUnicode) && forPreview) ? splitKeyValue[1] : decodeURIComponent(splitKeyValue[1]);

            if (fieldValue) {
                widgetGeneratorV2.formData[splitKeyValue[0]] = fieldValue;
            }
        });
    },
    onCheckboxClick() {
        const checkboxesIdWithDeps = [
            {
                checkboxClass: 'layout_top_logo',
                deps: ['layout_style_form_bg_color', 'layout_logo_style']
            },
            {
                checkboxClass: 'layout_title',
                deps: ['title_text']
            },
            {
                checkboxClass: 'layout_description',
                deps: ['layout_description_text']
            },
            {
                checkboxClass: 'responsive',
                deps: ['width', 'height'],
                defaultHidden: true
            }
        ];

        checkboxesIdWithDeps.forEach(({checkboxClass, deps, defaultHidden}) => {
            const checkbox = $(`.${checkboxClass} input`);

            checkbox.on('change', function() {
                const isChecked = Boolean($(this).is(':checked'));

                widgetGeneratorV2.updateFromCheckBoxValue(deps, defaultHidden ? !isChecked : isChecked);
            });
        });
    },
    /**
     *
     * @param {array<string>} deps
     * @param {boolean} show
     */
    updateFromCheckBoxValue(deps, show) {
        deps.forEach((dep) => {
            const depElement = Object.values($(`.${dep}`));
            if (show) {
                depElement.forEach((depElement) => {
                    const elementWrapper = $(depElement);

                    if (depElement.classList) {

                        if (elementWrapper.hasClass('wg-form-section-field')) {
                            elementWrapper.show(200);
                        }

                        depElement.removeAttribute('disabled');
                    }
                });
            }

            if (!show) {
                depElement.forEach((depElement) => {
                    const elementWrapper = $(depElement);

                    if (depElement.classList) {
                        if (elementWrapper.hasClass('wg-form-section-field')) {
                            elementWrapper.hide(200);
                        }

                        depElement.setAttribute('disabled', true);
                    }
                });
            }
        });
    },
    onFullScreenClick() {
        const fullScreenButton = $('#wg-fullscreen');
        const fullScreenCloseButton = $('#wg-fullscreen-close');
        const formSection = $('.wg-section.form');
        const scriptSection = $('.wg-section.script');
        const wgWidget = $('.wg-script');
        const iFrame = widgetGeneratorV2.widget;

        fullScreenButton.add(fullScreenCloseButton).on('click', function() {
            $('.wg-section.get-code').hide();

            if (!fullScreenButton.hasClass('isClicked')) {
                fullScreenButton.addClass('isClicked hide');
                fullScreenCloseButton.removeClass('hide');

                formSection.hide('slow');
                scriptSection.css('max-width', 'none');
                wgWidget.css('max-width', 'none');
                $('#wg-device-type-mobile').click();
                iFrame.css('width', `${$('#width').val()}px`);
                if (!widgetGeneratorV2.formData.responsive) {
                    iFrame.css('height', `${$('#height').val()}px`);
                }
            } else {
                fullScreenButton.removeClass('isClicked hide');
                fullScreenCloseButton.addClass('hide');

                formSection.show('slow');
                scriptSection.css('max-width', '576px');
                wgWidget.css('max-width', '375px');
                widgetGeneratorV2.updateWidgetView();
                widgetGeneratorV2.updateWidthAndHeight();
            }

            $('#wg-device-type').toggle();
        });

        widgetGeneratorV2.updateOnDeviceButtonClick();
    },
    onPickUpInputsClick() {
        const listOfPickUpInputIds = ['country', 'city', 'location'];

        listOfPickUpInputIds.forEach((pickUpInputId) => {
            const input = $(`#${pickUpInputId}`);

            /**
             * @param {InputEvent} event
             */
            input.on('change', function(event) {
                const inputValue = event.target.value;
                const inputId = event.target.id;

                if (inputId === 'location') {
                    return;
                }

                if (inputId === 'country' && !inputValue) {
                    widgetGeneratorV2.assignOptions('city', []);
                    widgetGeneratorV2.assignOptions('location', []);
                    widgetGeneratorV2.updateWidgetOnFormChange();
                    return;
                }

                const lang = window._d.s.language;

                fetch(`/${lang}/affiliate/widget/get-location-list?url=${inputValue}&locationId=${inputId}`)
                .then((data) => data.json())
                .then((result) => {
                    const { city = [], place = [] } = result;

                    if (city.length) {
                        widgetGeneratorV2.assignOptions('city', city);
                    }

                    widgetGeneratorV2.assignOptions('location', place);
                    widgetGeneratorV2.updateWidgetOnFormChange();
                });
            });
        });
    },
    removeAllOptions(selectBox) {
        while (selectBox.options.length > 0) {
            selectBox.remove(0);
        }
    },
    /**
     * @param {string} id
     * @param {array<name, url>} listOfLocations
     */
    assignOptions(id, listOfLocations) {
        const selectPlace = document.getElementById(id);
        widgetGeneratorV2.removeAllOptions(selectPlace);

        listOfLocations.forEach(({name, url}) => {
            const option = new Option(name, url);
            selectPlace.add(option, undefined);
        });
    },
    validateRequiredFields() {
        const requiredFields = ['aff_code'];

        requiredFields.forEach((field) => {
            const inputElement = $(`#${field}`);
            widgetGeneratorV2.validateField(inputElement, field);

            inputElement.on('keyup', function() {
                widgetGeneratorV2.validateField(inputElement, field);
            });
        });
    },
    /**
     * @param {HTMLInputElement} inputElement
     * @param {string} field
     */
    validateField(inputElement, field) {
        const inputElementValue = inputElement.val();
        const errorElement = $(`.error_${field}`);

        if (!inputElementValue) {
            document.querySelector(`#${field}`).scrollIntoView({ behavior: 'smooth', block: 'center'});
            errorElement.addClass('show');
            inputElement.addClass('error-border');
            widgetGeneratorV2.fieldErrors= true;
        } else {
            errorElement.removeClass('show');
            inputElement.removeClass('error-border');
            widgetGeneratorV2.fieldErrors = false;
        }
    },
    onReturnEditClick() {
        $('#wg-return-edit').on('click', function() {
            $('html').animate({ scrollTop: 0 }, 'slow');
            $('.wg-section.form').toggle(400);
            $('.wg-section.get-code').toggle(400);
        });
    },
    generateLocationUrl() {
        const locationFields = ['country', 'city', 'location'];
        const locationUrl = [];
        widgetGeneratorV2.formData['locations'] = '';

        locationFields.forEach((locationFieldName) => {
            if (!widgetGeneratorV2.formData[locationFieldName]) {
                return;
            }
            locationUrl.push(widgetGeneratorV2.formData[locationFieldName]);
        });

        if (locationUrl.length) {
            widgetGeneratorV2.formData['locations'] = locationUrl.join('/');
        }
    },
    addTextLinkToAffCodeSection() {
        const reqFields = ['language', 'locations'];
        const currencyField = $('#currency');
        const affCodeRegion = $('.wg-aff-code-region');
        const affCodeUrl = [location.origin];
        const currency = currencyField.val() ? `&currency=${ currencyField.val() }` : '';

        reqFields.forEach((fieldName) => {
            if (![undefined, 'en'].includes(widgetGeneratorV2.formData[fieldName])) {
                affCodeUrl.push(widgetGeneratorV2.formData[fieldName]);
            }
        });

        affCodeRegion.text(affCodeUrl.join('/')
            + `?a_aid=${widgetGeneratorV2.formData['aff_code']}`
            + widgetGeneratorV2.getChannelParams()
            + currency);
    },
    getChannelParams() {
        const reqFields = ['chan', 'data1', 'data2'];
        const paramsValue = {};

        reqFields.forEach((fieldName) => {
            const value  = widgetGeneratorV2.formData[fieldName];

            if (value) {
                paramsValue[fieldName] = widgetGeneratorV2.formData[fieldName];
            }
        });

        if (Object.keys(paramsValue).length) {
            return `&${new URLSearchParams(paramsValue).toString()}`;
        }

        return '';
    },
    /**
     *
     * @param {string} buttonClass
     * @param {string} regionTextClass
     */
    onCopyButtonCodeClick(buttonClass, regionTextClass) {
        const embedButton = $(`.${buttonClass}`);
        const embedRegionText = $(`.${regionTextClass}`).text();

        try {
            embedButton.on('click', function() {
                navigator.clipboard.writeText(embedRegionText);
                embedButton.children('span').text($('.clipboardCopied').text());

                const timer = setTimeout(() => {
                    embedButton.children('span').text($('.copyCode').text());
                    clearTimeout(timer);
                }, 2000);
            });
        } catch (exception) {
            // eslint-disable-next-line no-console
            console.error('Failed to copy: ', exception.toString());
        }
    },
    addTextLinkToEmbedCodeSection() {
        const { url: { widgetUrls: { script = 'https://www.discovercars.com/widget.js?v1' } = {} } } = _d;
        const dataAttributesList = [
            { name: 'id', value: 'dchwidget' },
            { name: 'src', value: script },
            { name: 'data-dev-env', value: 'com' },
            { name: 'data-location', value: widgetGeneratorV2.formData.locations },
            { name: 'data-lang', value: widgetGeneratorV2.formData.language },
            { name: 'data-currency', value: widgetGeneratorV2.formData.currency},
            { name: 'data-utm-source', value: widgetGeneratorV2.formData.aff_code},
            { name: 'data-utm-medium', value: 'widget'},
            { name: 'data-aff-code', value: 'a_aid'},
            { name: 'data-aff-channel', value: widgetGeneratorV2.formData.chan},
            { name: 'data-aff-data1', value: widgetGeneratorV2.formData.data1},
            { name: 'data-aff-data2', value: widgetGeneratorV2.formData.data2},
            { name: 'data-autocomplete', value: 'on'},
            { name: 'data-style-submit-bg-color', value: widgetGeneratorV2.formData.style_submit_bg_color},
            { name: 'data-style-submit-font-color', value: widgetGeneratorV2.formData.style_submit_font_color},
            { name: 'data-style-form-bg-color', value: widgetGeneratorV2.formData.style_form_bg_color},
            { name: 'data-style-form-font-color', value: widgetGeneratorV2.formData.style_form_font_color},
            { name: 'data-style-submit-text', value: widgetGeneratorV2.formData.submit_text},
            { name: 'data-style-title-color', value: widgetGeneratorV2.formData.style_title_color},
            { name: 'data-title-text', value: widgetGeneratorV2.formData.title_text},
            { name: 'async', value: 'async' },
            { name: 'data-style_rounded_corners', value: widgetGeneratorV2.formData.style_rounded_corners },
            { name: 'data-layout_benefits', value: widgetGeneratorV2.formData.layout_benefits },
            { name: 'data-layout_description', value: widgetGeneratorV2.formData.layout_description },
            { name: 'data-layout_description_text', value: widgetGeneratorV2.formData.layout_description_text },
            { name: 'data-layout_logo_style', value: widgetGeneratorV2.formData.layout_logo_style },
            { name: 'data-layout_powered_by', value: widgetGeneratorV2.formData.layout_powered_by },
            { name: 'data-layout_style_form_bg_color', value: widgetGeneratorV2.formData.layout_style_form_bg_color },
            { name: 'data-layout_title', value: widgetGeneratorV2.formData.layout_title },
            { name: 'data-layout_top_logo', value: widgetGeneratorV2.formData.layout_top_logo },
            { name: 'data-layout_supplier_logos', value: widgetGeneratorV2.formData.layout_supplier_logos }
        ];

        if (!widgetGeneratorV2.formData.responsive) {
            dataAttributesList.push({ name: 'data-iframe-height', value: widgetGeneratorV2.formData.height});
            dataAttributesList.push({ name: 'data-iframe-width', value: widgetGeneratorV2.formData.width});
        }

        const scriptTag = $('<script />');
        dataAttributesList.forEach(({ name, value }) => scriptTag.attr(name, value));

        $('.wg-embed-code-region').text(`<div>${scriptTag[0].outerHTML}</div>`);
    },
    onColorInputClick() {
        //Setting click from SVG to input field
        $('svg.color').each(function() {
            const that = $(this);

            that.on('click', function() {
                that.closest('.wg-form-section-field-color').find('input').click();
            });
        });

        $('.color-picker').each(function() {
            const that = $(this);

            that.on('click', function() {
                that.closest('.wg-form-section-field-color').find('input').click();
            });
        });

        //Getting value from input field to text
        $('.wg-form-section-field-color').find('input').each(function() {
            const that = $(this);

            that.on('change', function() {
                const inputType = that.attr('type');
                const colorValue = that.val();

                that.closest('.wg-form-section-field-color').find('.color-picker').css('backgroundColor', colorValue);

                if (inputType === 'text') {
                    that.closest('.wg-form-section-field-color').find('input[type="color"]').val(colorValue);
                    widgetGeneratorV2.updateWidgetOnFormChange();
                } else if (inputType === 'color') {
                    that.closest('.wg-form-section-field-color').find('.hex-input').val(colorValue);
                }
            });
        });
    },
    updateWidgetOnEveryFormChange() {
        $('#wg-form input').add('#wg-form select').each(function() {
            const input = $(this);

            input.on('change', function() {
                if ($(this).hasClass('.hex-input')) { return; }
                widgetGeneratorV2.updateWidgetOnFormChange();
            });
        });
    },
    getFormReverseData(initialFormData = widgetGeneratorV2.formData) {
        const formData  = [];
        Object.entries(initialFormData).forEach(([key, value]) => {
            formData.push(`${key}=${value}`);
        });

        return formData.join('&');
    },
    updateWidgetOnFormChange() {
        widgetGeneratorV2.roundedBordersUpdate();
        widgetGeneratorV2.widget = $('#discoFrameId'); //Hack to fix bug on reset button click
        widgetGeneratorV2.getFormData(true);
        widgetGeneratorV2.generateLocationUrl();
        const widgetURL = 'https://widget.discovercars.com';
        const lang = widgetGeneratorV2.formData.language ? `/${widgetGeneratorV2.formData.language}` : '';
        const location = widgetGeneratorV2.formData.locations;
        const rawFormData = widgetGeneratorV2.getFormReverseData();
        const src = `${widgetURL}${lang}/locations/${location}?` + rawFormData;

        widgetGeneratorV2.updateWidthAndHeight();
        widgetGeneratorV2.widget.attr('src', src);
    },
    onResetButtonCLick() {
        $('#wg-reset').on('click', function(event) {
            event.preventDefault();
            location.reload();
        });
    },
    roundedBordersUpdate() {
        const isChecked = Boolean($('#style_rounded_corners').is(':checked'));

        if (isChecked) {
            widgetGeneratorV2.widget.attr('style', 'border-radius: 8px');
        } else {
            widgetGeneratorV2.widget.removeAttr('style');
        }
    },
    onScrollToPreviewClick() {
        const scrollText = $('#wg-scrollText');

        $('#wg-scroll').on('click', function() {
            $('#scrollOpen').toggle();
            $('#scrollClose').toggle();
            scrollText.toggle(100);
        });

        scrollText.on('click', function() {
            $('.wg-section.script').get(0).scrollIntoView({behavior: 'smooth'});
        });
    },
    updateOnDeviceButtonClick() {
        const mobileButton = $('#wg-device-type-mobile');
        const desktopButton = $('#wg-device-type-desktop');
        const activeClasses = 'bg-blue-100-new border-blue-600-new text-blue-700-new';
        const inactiveClassList = 'bg-white border-gray-300-new text-gray-600-new';

        mobileButton.on('click', function() {
            const that = $(this);

            if (!that.hasClass(activeClasses)) {
                that.addClass(activeClasses);
                that.removeClass(inactiveClassList);
            }

            if (!desktopButton.hasClass(inactiveClassList)) {
                desktopButton.addClass(inactiveClassList);
                desktopButton.removeClass(activeClasses);
            }

            widgetGeneratorV2.updateWidgetOnFormChange();
            widgetGeneratorV2.updateWidgetView();
        });

        desktopButton.on('click', function() {
            const that = $(this);

            if (!that.hasClass(activeClasses)) {
                that.addClass(activeClasses);
                that.removeClass(inactiveClassList);
            }

            if (!mobileButton.hasClass(inactiveClassList)) {
                mobileButton.addClass(inactiveClassList);
                mobileButton.removeClass(activeClasses);
            }

            widgetGeneratorV2.setDesktopMode();
            widgetGeneratorV2.updateWidgetView('1152px');
        });
    },
    setDesktopMode() {
        $("<input type='text' name='layout_is_desktop' id='layout_is_desktop' value='on'/>").appendTo('#wg-form');
        widgetGeneratorV2.updateWidgetOnFormChange();
        $('#layout_is_desktop').remove();
    },
    updateWidgetView(maxWidth = '375px') {
        $('.wg-script').css('max-width', maxWidth);
        widgetGeneratorV2.widget.css('width', maxWidth);
    },
    updateWidthAndHeight() {
        const height = widgetGeneratorV2.formData.height;
        const width = widgetGeneratorV2.formData.width;

        if (widgetGeneratorV2.formData.responsive) {
            widgetGeneratorV2.widget.attr('width', '100%');
            return;
        }

        widgetGeneratorV2.widget.attr('height', `${height}px`);
        widgetGeneratorV2.widget.attr('width', `${width}px`);
    }
};
